import { FC } from 'react';

import { TabsRoot } from './Tabs.Root';
import { Tab, TabType } from './Tab';

/**
 * Пропсы компонента табов
 */
export type TabsProps = {
  tabs: TabType[];
  activeTab: string;
  setActiveTab: (activeTab: string) => void;
};

/**
 * Компонент табов
 */
export const Tabs: FC<TabsProps> = ({ tabs, activeTab, setActiveTab }) => {
  return (
    <TabsRoot>
      {tabs.map((tab) => (
        <Tab
          tab={tab}
          key={`tab-${tab.id}`}
          isActive={activeTab === tab.id}
          activate={setActiveTab}
        />
      ))}
    </TabsRoot>
  );
};
